import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class AttributeImportService {

  constructor(private apiService: ApiService,
    ) { }

  public attributeExcelImport(model: any): Observable<RestResponse> {
    const url = `${API.AttributeImport.attributeExcelImport}`;  
    return this.apiService.post(url, model);
  }

}
